module.exports = __webpack_public_path__ + "img/time2.f69d5397.svg";